/**
 * Expired Media Key Status.
 *
 *
 * @beta
 */
export const EXPIRED = 'expired'
